export { useFluent_unstable as useProviderContext } from '@fluentui/react-shared-contexts';
